import { sharedAtom } from '../utilities/jotai-utils';

export const featureHubState = sharedAtom('featurehub', {
  featureFlags: {},
  isLoading: undefined,
  error: false,
  loaded: false
});
